import { render, staticRenderFns } from "./WhiteSalviLogo.vue?vue&type=template&id=69d97be4&scoped=true&"
var script = {}
import style0 from "./WhiteSalviLogo.vue?vue&type=style&index=0&id=69d97be4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d97be4",
  null
  
)

export default component.exports